// extracted by mini-css-extract-plugin
export default {"root":"qyyKXdcq","icon":"dXTFqzVU","thermometer":"yYEF-YDE","temperature":"R1ENpvZz","waterTemperature":"Ll2YQsP2"};